import type { ReactNode } from 'react';

interface SettingsCardProps {
  title: string;
  action: ReactNode;
  children: ReactNode;
}

export function SettingsCard({ title, action, children }: SettingsCardProps) {
  return (
    <div className="bg-background border-border flex flex-col rounded-sm border px-6 py-2">
      <div className="flex items-center justify-between px-0 py-2">
        <h3 className="font-medium">{title}</h3>
        {action}
      </div>
      <div className="border-border w-full border-t" />
      <div className="py-2">{children}</div>
    </div>
  );
}
